module.exports = __webpack_public_path__ + "img/area_8.e349963a.png";